export const MENU_NAME = [
  { id: 1, path: "/", name: "SNPLAB" },
  { id: 2, path: "/about", name: "ABOUT US" },
  { id: 3, path: "/service", name: "SERVICE" },
  { id: 4, path: "/press", name: "PRESS" },
];
